import React, { FC, useRef } from "react";
import Slider from "react-slick";
import slugify from "slugify";
import { PageSection } from "../PageSection/PageSection";
import { Button } from "../Button/Button";
import "./CardCarousel.scss";
import ForwardIcon from "../../assets/heroicons/chevron.svg";

export interface CardCarouselProps {
	children: React.ReactNode;
	heading: string;
	cta?: string;
	ctaLink?: string;
}

export const CardCarousel: FC<CardCarouselProps> = ({
	heading,
	children,
	cta,
	ctaLink,
}) => {
	const sliderRef = useRef<Slider | null>(null);

	const settings = {
		autoplay: false,
		autoplaySpeed: 2000,
		autoplayHoverPause: true,
		useTransforms: true,
		centerMode: false,
		arrows: false,
		speed: 333,
		dots: false,
		className: "sliderCard",
		infinite: true,
		slidesToShow: 3,
		variableHeight: true,
		slidesToScroll: 1,
		initialSlide: 0,
		accessibility: true,
		responsive: [
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	};
	return (
		<PageSection
			id={slugify(heading, { lower: true, strict: true })}
			heading={heading}
		>
			<Slider ref={sliderRef} {...settings}>
				{children}
			</Slider>
			{cta && (
				<div id="cta" className="cta">
					<Button
						variant="secondary"
						onClick={() => sliderRef.current?.slickPrev()}
					>
						<ForwardIcon
							focusable="false"
							aria-hidden="true"
							className="icon icon--prev"
						/>
					</Button>
					{/* <Button variant="secondary" to={ctaLink}>
						View More Games
					</Button> */}
					<Button
						variant="secondary"
						onClick={() => sliderRef.current?.slickNext()}
					>
						<ForwardIcon
							focusable="false"
							aria-hidden="true"
							className="icon"
						/>
					</Button>
				</div>
			)}
		</PageSection>
	);
};
